module.exports = __webpack_public_path__ + "static/img/组 24252.9731fe2b.png";